import {red} from 'view/theme/colors';

type TrashIconProps = {
  color?: string;
  size?: number;
};

export default function TrashIcon({color = red, size = 24}: TrashIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none">
      <path d="M3.5 6H5.5H21.5" fill={color} />
      <path
        d="M3.5 6H5.5H21.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 6V4C8.5 3.46957 8.71071 2.96086 9.08579 2.58579C9.46086 2.21071 9.96957 2 10.5 2H14.5C15.0304 2 15.5391 2.21071 15.9142 2.58579C16.2893 2.96086 16.5 3.46957 16.5 4V6M19.5 6V20C19.5 20.5304 19.2893 21.0391 18.9142 21.4142C18.5391 21.7893 18.0304 22 17.5 22H7.5C6.96957 22 6.46086 21.7893 6.08579 21.4142C5.71071 21.0391 5.5 20.5304 5.5 20V6H19.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
